import { api, roles } from '@/utils';

export default {
  name: 'StakeholderDetail',
  components: {},
  props: {},
  data: () => ({
    loading: false,
    apiVersion: 1,
    id: 0,
    name: '',
    apicsCode: '',
    vat: '',
    nxtEntityId: '',
    selectedRoles: [],
    roles,
    formFields: {
      id: {
        name: 'id',
        label: 'Code',
        validation: 'required',
      },
      name: {
        name: 'name',
        label: 'Name',
      },
      nxtEntityId: {
        name: 'nxtEntityId',
        label: 'NxtEntityId',
      },
      vat: {
        name: 'vat',
        label: 'Vat',
      },
      apicsCode: {
        name: 'apicsCode',
        label: 'ApicsCode',
      },
      roles: {
        name: 'roles',
        label: 'Roles',
      },
    },
  }),
  computed: {
    isDetail() {
      return this.$route.params.id != null;
    },
  },
  methods: {
    saveStakeholderForm() {
      this.$validator.validateAll()
        .then((isValid) => {
          if (isValid) {
            this.loading = true;

            const postObject = {
              name: this.name,
              nxtEntityId: this.nxtEntityId,
              vat: this.vat,
              apicsCode: this.apicsCode,
              roles: this.selectedRoles,
            };

            if (postObject.apicsCode === '') {
              postObject.apicsCode = null;
            }

            if (this.$route.params.id === undefined) {
              const url = '/stakeholders';

              api.post(url, postObject)
                .then(() => {
                  this.loading = false;
                  this.$router.push({ name: 'stakeholder-overview' });

                  if (this.isDetail) {
                    this.$eventHub.$emit('show-snackbar', 'Stakeholder was updated');
                  } else {
                    this.$eventHub.$emit('show-snackbar', 'Stakeholder was created');
                  }
                })
                .catch((error) => {
                  this.loading = false;
                  console.log('something went wrong');
                  this.$eventHub.$emit('show-snackbar', error);
                });
            } else {
              // BASEURL
              const url = `/stakeholders/${this.id}`;

              api.put(url, postObject)
                .then(() => {
                  this.loading = false;
                  this.$router.push({ name: 'stakeholder-overview' });

                  if (this.isDetail) {
                    this.$eventHub.$emit('show-snackbar', 'Stakeholder was updated');
                  } else {
                    this.$eventHub.$emit('show-snackbar', 'Stakeholder was created');
                  }
                })
                .catch((error) => {
                  this.loading = false;
                  console.log('something went wrong');
                  this.$eventHub.$emit('show-snackbar', error);
                });
            }
          }
        });
    },
    getStakeholder() {
      if (this.$route.params.id != null) {
        // BASEURL
        const url = `/stakeholders/${this.$route.params.id}`;

        api.get(url)
          .then((response) => {
            this.id = response.data.id;
            this.name = response.data.name;
            this.apicsCode = response.data.apicsCode;
            this.vat = response.data.vat;
            this.nxtEntityId = response.data.nxtEntityId;
            this.selectedRoles = response.data.roles;
          })
          .catch((error) => {
            this.$eventHub.$emit('show-snackbar', error);
          });
      }
    },
    cancelStakeholderForm() {
      this.$router.push({ name: 'stakeholder-overview' });
    },
  },
  created() {
    this.getStakeholder();
  },
};
